/**
 * CPF/CNPJ: normalização, validação de DV e formatação.
 *
 * O backend valida os dígitos verificadores e rejeita com 422
 * (`stakeholder_document_invalid`). Validar aqui é UX — feedback antes do
 * round-trip; o servidor continua sendo a autoridade.
 *
 * O transporte é SÓ DÍGITOS (11 ou 14). A máscara é exibição.
 */

export function onlyDigits(v: string): string {
  return v.replace(/\D/g, '')
}

function dv(digits: string, pesoInicial: number): number {
  let soma = 0
  let peso = pesoInicial
  for (const ch of digits) {
    soma += Number(ch) * peso
    peso -= 1
    if (peso < 2) peso = 9
  }
  const resto = soma % 11
  return resto < 2 ? 0 : 11 - resto
}

export function isValidCpf(raw: string): boolean {
  const d = onlyDigits(raw)
  if (d.length !== 11) return false
  // Rejeita 00000000000, 11111111111… — passam na conta de DV mas não existem.
  if (/^(\d)\1{10}$/.test(d)) return false
  const base = d.slice(0, 9)
  const d1 = dv(base, 10)
  const d2 = dv(base + String(d1), 11)
  return d === base + String(d1) + String(d2)
}

export function isValidCnpj(raw: string): boolean {
  const d = onlyDigits(raw)
  if (d.length !== 14) return false
  if (/^(\d)\1{13}$/.test(d)) return false
  const base = d.slice(0, 12)
  const d1 = dv(base, 5)
  const d2 = dv(base + String(d1), 6)
  return d === base + String(d1) + String(d2)
}

/** O backend aceita CPF (11) ou CNPJ (14) no mesmo campo `document`. */
export function isValidDocument(raw: string): boolean {
  const d = onlyDigits(raw)
  if (d.length === 11) return isValidCpf(d)
  if (d.length === 14) return isValidCnpj(d)
  return false
}

export function formatDocument(raw: string): string {
  const d = onlyDigits(raw)
  if (d.length === 11) return d.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
  if (d.length === 14) return d.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
  return raw
}
